// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarCircle_avatar__reL8y","sm":"AvatarCircle_sm__noJyW","md":"AvatarCircle_md__3ensp","lg":"AvatarCircle_lg__29MqW","photo":"AvatarCircle_photo__RM2C2"};